<template>
    <div class="form-field form-autocomplete form-tag" :rel="name">
        <div class="form-label">
            <label>{{ label }}</label>
        </div>
        <div class="form-input">
            <div class="form-input-wrapper">
                <component-multiselect v-model="internalValue"
                                       tag-placeholder="Add this as new tag"
                                       placeholder="Search or add a tag"
                                       label="name"
                                       track-by="code"
                                       :options="options"
                                       :multiple="true"
                                       :taggable="true"
                                       @tag="addTag">
                 </component-multiselect>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'FormTag',
        props: ['value','label','name','placeholder','multiple', 'default','options','callback'],
        data: function () {
            return {
                internalValue: ''
            }
        },
        created: function() {
            this.internalValue = this.value;
            this.isMultiple = this.multiple == 'true' ? true : false;
            this.onChange = this.callback ? true : false;
        },
        methods: {
            addTag (newTag) {
                const tag = {
                    name: newTag,
                    id: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
                }
                this.options.push(tag)
                this.value.push(tag)
            },
        },
        watch: {
            'value'(newVal, oldVal) {
                this.internalValue = newVal
            },
            'default'(newVal, oldVal) {
                if( newVal && this.options){
                    for (let item of this.options) {
                        if( item.id && item.id.toString().toLowerCase() == newVal.toString().toLowerCase() ){
                            this.internalValue = item;
                        }
                    }
                }
            },
            'internalValue'(newVal, oldVal) {
                this.$emit('input', this.internalValue);
                if( this.onChange ){
                    this.callback(this.internalValue)
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/form/Tag.vue